import React, { useContext, useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import Cancel from "@material-ui/icons/Cancel";
import Lottie from "lottie-react-web";
import {Link, useHistory, useLocation} from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import Fade from "@material-ui/core/Fade";
import StarRatings from "react-star-ratings";
import CloseIcon from "@material-ui/icons/Close";
import { useMediaQuery } from "react-responsive";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from "@material-ui/core/Snackbar";
import MoreVert from "@material-ui/icons/MoreVert";
import { TextareaAutosize } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import PictureAsPdfRoundedIcon from "@material-ui/icons/PictureAsPdfRounded";
import searchInstructor from "../../../assets/lottie/searching_instructor.json";

import {
  UserContext,
  ThemeContext,
} from "../../../context";
import {BlazeSessionContext} from "../../../context/blaze/BlazeSessionContext";
import pdfIcon from "../../../assets/images/pdf.svg";
import BlazeStudentCall from "../../blazeCall";
import SendIcon from "../../../assets/blaze/sendIcon";
import noFilesIcon from "../../../assets/images/icons/no_files.svg";
import {castIndianTime, getGrade, starPath} from "../../../helpers";
import { ReservationChats, ModalGallery } from "../../../components";
import noImagesIcon from "../../../assets/images/icons/no_images.svg";
import verfifiedCheck from "../../../assets/images/icons/verified.png";
import imageGallery from "./../../../assets/images/blaze/imageGallery.svg";
import circularProgress from "../../../assets/lottie/circularProgress.json";
import { groupBlazeMessages, monthToStringFormatter } from "../../../helpers";
import roundedVideoCamera from "../../../assets/blaze/rounded_video_camera.svg";
import {
  getRtmToken,
  sendBlazeChat,
  getCallStartTs,
  startHandoverStudent,
  getInstructorRatings,
  getBlazeReservationChats,
  getMoreBlazeReservationChats,
  blazeDecreaseMessageCount,
  getLatestBlazeReservationChats,
} from "../../../database";

import "./style.scss";
import { getIndianTime } from "../../../helpers";
import { endSession } from "../../../database/blaze/fetch-data";
import {ModalContext} from "../../../context/global/ModalContext";
import {rdb} from "../../../firebase_config";

export const EndSessionModal = ({onConfirm, title, description}) => {
  const [isDarkMode] = useContext(ThemeContext).theme;
  const [, setConfirmationModalData] = useContext(ModalContext).state;
  const [loading, setLoading] = useState(false);

  return (
    <div className={"confirmation-modal" + (isDarkMode ? ' dark' : '')}>
      <h1>{title || 'Confirmation'}</h1>
      <Cancel className="close-rating" onClick={() => {setConfirmationModalData(data => ({...data, open: false}))}} />
      <p className="text">{description || 'Are you sure?'}</p>
      <div className="flex-buttons">
        <button className="danger btn" style={{marginRight: '10px'}}
             onClick={async () => {
               document.getElementsByTagName('body')[0].style.pointerEvents = 'none';
               await onConfirm(setLoading);
               // Loader here
               document.getElementsByTagName('body')[0].style.pointerEvents = 'all';
               setConfirmationModalData(data => ({...data, open: false}))
             }}
        >{
          loading ? (
            <Lottie options={{animationData: circularProgress, loop: true}} style={{filter: 'invert(1)',padding: 0, width: '30px'}}/>
          ) : 'Yes'
        }</button>
        <button className="btn" style={{background: 'gray'}} onClick={() => {
          setConfirmationModalData(data => ({...data, open: false}))
        }}>No</button>
      </div>
    </div>
  )
}

export default function BlazeReservations({
  currentReservation,
  setIsChatOpen,
}) {
  const [user] = useContext(UserContext).user;
  const [, setPushyData] = useContext(UserContext).pushyData;
  const [instructorRating] = useContext(BlazeSessionContext).instructorRating;
  const [, setConfirmationModalData] = useContext(ModalContext).state;
  const [openBlazeCall, setOpenBlazeCall] =
    useContext(UserContext).openBlazeCallModal;
  const [, setCallStartTs] = useContext(BlazeSessionContext).callStartTs;
  const [studentActivity] = useContext(BlazeSessionContext).studentActivity;
  const [openChat, setOpenChat] = useContext(BlazeSessionContext).openChat;

  const [isDark] = useContext(ThemeContext).theme;
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });

  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [message, setMessage] = useState("");
  const [chatText, setChatText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [moreChat, setMoreChat] = useState(false);
  const [chatsData, setChatsData] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [chatImages, setChatImages] = useState(null);
  const [openPickers, setOpenPickers] = useState(false);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isTabActive, setIsTabActive] = useState(true);
  const [newMessage, setNewMessage] = useState(false);
  const [chatDocuments, setChatDocuments] = useState(null);

  const [currentSessionUnreadCount] =
    useContext(BlazeSessionContext).currentSessionUnreadCount;
  const [, setOpenRatingModal] =
    useContext(BlazeSessionContext).openRatingModal;
  const [, setRatingModalDetails] =
    useContext(BlazeSessionContext).ratingModalDetails;

  const changeRef = useRef(true);
  const pickerRef = useRef(null);

  const handleBlazeCallClose = () => {
    setOpenBlazeCall(false);
    setOpenChat(false);
  };
  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const getSubject = (arr) => {
    let sub = "";
    arr.map((w) => (sub = sub + " " + w));
    return sub.slice(1);
  };

  const subjectName = (skill) => {
    let splitted = skill?.split("_");

    if (splitted.length > 0) {
      return splitted.length === 3
        ? splitted[2] === "maths"
          ? "Mathematics"
          : splitted[2]
        : getSubject(splitted.slice(3));
    }
  };

  const handleMessageSubmit = async () => {
    setIsSending(true);
    setChatText("");
    await sendBlazeChat({
      user: user,
      text: chatText,
      reference: currentReservation?.reference,
      images: images,
      pdfs: pdfs,
      session_id: currentReservation?.id,
      session_topic: currentReservation?.topic,
      receiver_id: currentReservation?.instructor_id,
      student_grade: getGrade(currentReservation?.skill),
      type: images.length > 0 || pdfs.length > 0 ? "attachment" : "text",
    });
    setPdfs([]);
    setImages([]);
    setChatText("");
    setIsSending(false);
    changeRef.current = true;
  };

  const iterateMedia = (e) => {
    let _images = [];
    let _documents = [];

    e &&
      e.forEach((chat) => {
        if (chat?.type === "image") {
          _images.push({
            timestamp: new Date(chat?.timestamp),
            url: chat?.attachment?.url,
          });
        } else if (chat?.type === "document") {
          _documents.push({
            name: chat?.attachment?.name,
            timestamp: new Date(chat?.timestamp),
            url: chat?.attachment?.url,
          });
        }
      });

    setChatImages(_images);
    if (_documents.length !== chatDocuments?.length)
      setChatDocuments(_documents);
  };

  const getLatestChats = (chats) => {
    getLatestBlazeReservationChats({
      reference: currentReservation?.reference,
      user_id: user?.uid,
      doc: chats[chats?.length - 1],
      receiverId: currentReservation?.instructor_id,
      callback: (e, unreadCount) => {
        iterateMedia([...(chats || []), ...e]);
        setChatsData(groupBlazeMessages([...(chats || []), ...e], unreadCount));
        setMoreChat(true);
      },
    });
  };

  const handleSnackClose = () => {
    setOpenSnack(false);
  };

  useEffect(() => {
    setPdfs([]);
    setImages([]);
    setChatText("");
    setChatsData(null);
    setOpenPickers(false);

    getChatsFn();
  }, [currentReservation?.id]);

  const onFocus = () => {
    setIsTabActive(true);
    setNewMessage(false);
  };

  const onBlur = () => {
    setIsTabActive(false);
  };

  useEffect(() => {
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);

    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  useEffect(() => {
    if(!currentReservation || !user) return;
    if (currentSessionUnreadCount > 0 && isTabActive && !openBlazeCall) {
      blazeDecreaseMessageCount(
        currentReservation?.reference,
        currentSessionUnreadCount,
        user?.grade,
        user?.uid,
        user?.is_external_instructor,
        currentReservation?.instructor_id,
        currentReservation?.id
      );
    }

    if (
      openChat &&
      openBlazeCall &&
      currentSessionUnreadCount > 0 &&
      isTabActive
    ) {
      blazeDecreaseMessageCount(
        currentReservation?.reference,
        currentSessionUnreadCount,
        user?.grade,
        user?.uid,
        user?.is_external_instructor,
        currentReservation?.instructor_id,
        currentReservation?.id
      );
    }
  }, [currentSessionUnreadCount, user, currentReservation, isTabActive, openBlazeCall, openChat]);

  const imageSelectionHandler = (e) => {
    const { files } = e.target;

    let _images = [];

    let _num =
      files.length + images.length > 1
        ? images.length - files.length > 0
          ? images.length - files.length
          : 1
        : files.length;

    if (files.length + images.length > 1) {
      setMessage("Only 1 image is allowed at a time");
      setOpenSnack(true);
      setTimeout(() => setOpenSnack(false), 2500);
    }

    if (images.length !== 1) {
      for (let i = 0; i < _num; i++) {
        _images[i] = {
          url: URL.createObjectURL(files[i]),
          ext: files[i].name.split(".").slice(-1)[0],
          name: files[i].name,
        };
      }
      setImages(images.concat(_images));
      setOpenPickers(false);
    }
    e.target.value = "";
  };

  const pdfSelectionHandler = (e) => {
    const { files } = e.target;

    let _pdfs = [];

    let _num =
      files.length + pdfs.length > 1
        ? pdfs.length - files.length > 0
          ? pdfs.length - files.length
          : 1
        : files.length;

    if (files.length + pdfs.length > 1) {
      setMessage("Only 1 pdf is allowed at a time");
      setOpenSnack(true);
      setTimeout(() => setOpenSnack(false), 2500);
    }

    if (pdfs.length !== 1) {
      for (let i = 0; i < _num; i++) {
        _pdfs[i] = {
          url: URL.createObjectURL(files[i]),
          ext: files[i].name.split(".").slice(-1)[0],
          name: files[i].name,
          size: parseFloat(files[i].size / 1024 / 1024).toFixed(2),
        };
      }
      setPdfs(pdfs.concat(_pdfs));
    }
    e.target.value = "";
    setOpenPickers(false);
  };

  const handleImageDelete = () => setImages([]);
  const handlePdfDelete = () => setPdfs([]);

  const isChattingDisabled = (status) => status === "completed";

  const handleHandover = async () => {
    const response = await startHandoverStudent({
      sessionId: currentReservation?.id,
      meetingId: studentActivity?.meetingId,
      isSmallScreen: isSmallScreen,
    });

    const _callStartTs = await getCallStartTs({
      sessionId: currentReservation?.id,
      meetingId: studentActivity?.meetingId,
    });

    setCallStartTs(_callStartTs);

    const rtmToken = await getRtmToken({ sessionId: currentReservation?.id });

    if (response && rtmToken) {
      setPushyData({
        session_id: currentReservation?.id,
        meeting_id: studentActivity?.meetingId,
        instructor_id: currentReservation?.instructor_id,
        rtm_token: rtmToken,
      });

      setOpenBlazeCall(true);
    }
  };

  const getChatsFn = async () => {
    let _data = await getBlazeReservationChats({
      reference: currentReservation?.reference,
      user_id: user?.uid,
      limit: 25,
    });

    console.log('_data - ', _data);

    if (_data?.length === 25) {
      setTimeout(() => setMoreChat(true), 500);
    } else {
      setMoreChat(false);
    }

    iterateMedia(_data);
    setChatsData(groupBlazeMessages(_data));
    getLatestChats(_data);
  };

  const getMoreChatsFn = async (
    chats,
    setIsFetching,
    setAutoScroll,
    firstChild,
    fetchedLength
  ) => {
    let _data = await getMoreBlazeReservationChats({
      reference: currentReservation?.reference,
      user_id: user?.uid,
      doc: chats[0],
    });

    if (_data?.length < 10) {
      setMoreChat(false);
    } else {
      setMoreChat(true);
    }
    fetchedLength.current = _data.length;

    let finalData = [..._data, ...chats];

    iterateMedia(finalData);
    firstChild.current.scrollIntoView();

    setChatsData(groupBlazeMessages(finalData));
    setIsFetching(false);
    setTimeout(() => {
      setAutoScroll(true);
    }, 100);
  };

  const handleSessionCompleted = async (setLoading) => {
    setLoading(true);
    const ist = await castIndianTime(true);
    if (currentReservation?.session_status === "accepted") {
      setAnchorEl(null);
      setOpenRatingModal(true);

      const instructorRating = await getInstructorRatings({
        instructorId: currentReservation?.instructor_id,
      });
      setLoading(false);

      setRatingModalDetails({
        instructor_id: currentReservation?.instructor_id,
        instructor_name: currentReservation?.instructor_name,
        instructor_profile_pic: currentReservation?.instructor_profile_pic,
        session_id: currentReservation?.id,
        instructor_rating: instructorRating,
        topic: currentReservation?.topic,
        pending: false,
        skill: currentReservation?.skill,
      });
    } else if (currentReservation?.session_status === "outstanding") {
      await endSession({
        sessionId: currentReservation?.id,
        completedTs: ist.serverISOString,
        ratingTs: null,
        rating: null,
        studentId: currentReservation?.student_id,
        instructorId: currentReservation?.instructor_id,
        instructorName: currentReservation?.instructor_name,
        instructorProfilePic: currentReservation?.instructor_profile_pic,
        skill: currentReservation?.skill,
        topic: currentReservation?.topic,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setOpenPickers(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  const getTotalCallDuration = () => {
    let totalDuration = currentReservation?.aggregated_duration;

    let duration = Math.round(totalDuration / 60);

    return duration + " minute" + (duration > 1 ? "s" : "");
  };

  return (
    <>
      <div className="blaze__reservation__wrapper blaze-theme-1">
        <div className="reservation__content__wrapper">
          <div className="reservation__chat__wrapper">
            <div className="reservation__bar">
              <div className="reservation__details__bar">
                <div className="reservation__details__backdrop">
                  <div
                    className="reservation__chat__back"
                    onClick={() => setIsChatOpen(false)}
                  >
                    <Link to="/">
                      <ArrowBackIcon />
                    </Link>
                  </div>
                  <div className="reservation__details">
                    <div
                      className="vertical-line"
                      style={{
                        backgroundColor:
                          currentReservation?.subject_color_gradient[0],
                        boxShadow: `2px 0 6px 2px ${currentReservation?.subject_color_gradient[1]}80`,
                      }}
                    />
                    <div className="reservation__name">
                      {currentReservation?.topic}
                    </div>
                    <div className="reservation__details__sm">
                      <div className="instructor-details">
                        <div className="instructor-inner">
                          {currentReservation?.instructor_profile_pic ? (
                            <div className="instructor-img">
                              <img
                                src={currentReservation?.instructor_profile_pic}
                                className="image__instructor"
                                alt="ins"
                                draggable={false}
                              />
                              <img
                                src={verfifiedCheck}
                                alt="v"
                                className="image__verified"
                                draggable={false}
                              />
                            </div>
                          ) : (
                            <div className="instructor-search">
                              <Lottie
                                options={{
                                  animationData: searchInstructor,
                                  loop: true,
                                }}
                              />
                            </div>
                          )}

                          <section>
                            <div>
                              <h4>
                                {currentReservation?.instructor_name
                                  ? currentReservation.instructor_name?.split(
                                      " "
                                    )[0] + " Sir"
                                  : currentReservation?.session_status ===
                                    "completed"
                                  ? "Unassigned"
                                  : "Searching..."}
                              </h4>
                              {/*{instructorRating > 0 && (*/}
                                <StarRatings
                                  name="rating"
                                  numberOfStars={5}
                                  starSpacing="2px"
                                  starDimension="20px"
                                  rating={instructorRating ?? 0}
                                  svgIconPath={starPath}
                                  starRatedColor="#fec107"
                                  starHoverColor="#fec107"
                                  svgIconViewBox="0 0 207.802 207.748"
                                />
                              {/*)}*/}
                            </div>
                            <h6>
                              PuStack {subjectName(currentReservation?.skill)}{" "}
                              Expert
                            </h6>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="reservation__options">
                    {studentActivity?.isEngaged &&
                      studentActivity?.sessionId === currentReservation?.id && (
                        <div className="popIn">
                          <button
                            onClick={handleHandover}
                            className="call__btn"
                          >
                            <img
                              src={roundedVideoCamera}
                              alt="vc"
                              draggable={false}
                            />
                            <span>JOIN</span>
                          </button>
                        </div>
                      )}
                    {!isChattingDisabled(
                      currentReservation?.session_status
                    ) && (
                      <MoreVert
                        aria-label="more"
                        aria-haspopup="true"
                        onClick={handleClick}
                        aria-controls="session-menu"
                        className="vert__icon"
                        style={{
                          fill: isDark ? "white" : "black",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    <Menu
                      keepMounted
                      id="session-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                      PaperProps={{
                        style: { maxHeight: 48 * 4.5, width: "20ch" },
                      }}
                    >
                      <MenuItem key={0} onClick={() => {
                        setConfirmationModalData({
                          open: true,
                          Children: <EndSessionModal
                            title="End Session"
                            description="Are you sure you want to end this session?"
                            onConfirm={handleSessionCompleted}
                          />
                        })
                      }}>
                        End Session
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>

            <div className="reservation__chat__inner">
              {chatsData && (
                <ReservationChats
                  chats={chatsData}
                  moreChat={moreChat}
                  key={currentReservation?.id}
                  getMoreChatsFn={getMoreChatsFn}
                />
              )}
            </div>
            <div className="blaze__chat__image__preview fadeOutDown">
              {images.length > 0 &&
                images.map((image, i) => (
                  <div className="image__preview">
                    <CloseIcon
                      onClick={() => handleImageDelete(i)}
                      className="imagePreviewDialog_closeIcon"
                    />
                    <img src={image.url} alt="X" draggable={false} />
                  </div>
                ))}

              {pdfs.length > 0 && (
                <div className="pdf__preview">
                  <CloseIcon
                    onClick={handlePdfDelete}
                    className="imagePreviewDialog_closeIcon"
                  />
                  <img src={pdfIcon} alt="X" draggable={false} />
                  <span>{pdfs[0].size} MB</span>
                </div>
              )}
            </div>

            <div className="user__chat__input">
              <div
                className={openPickers ? "show__pickers" : "close__pickers"}
                ref={pickerRef}
              >
                <label className="blaze__image" htmlFor="blaze-image-picker">
                  <img
                    src={imageGallery}
                    alt="chatImageInput"
                    className="blaze__input__image"
                    draggable={false}
                  />
                </label>
                <input
                  accept="image/*"
                  type="file"
                  id="blaze-image-picker"
                  style={{ display: "none" }}
                  onChange={imageSelectionHandler}
                  disabled={isChattingDisabled(
                    currentReservation?.session_status
                  )}
                />

                <label className="blaze__pdf" htmlFor="blaze-pdf-picker">
                  <PictureAsPdfRoundedIcon />
                </label>
                <input
                  type="file"
                  id="blaze-pdf-picker"
                  accept="application/pdf"
                  style={{ display: "none" }}
                  onChange={pdfSelectionHandler}
                  disabled={isChattingDisabled(
                    currentReservation?.session_status
                  )}
                />
              </div>
              <div
                className={isDark ? "blaze__picker dark" : "blaze__picker"}
                onClick={() =>
                  !isChattingDisabled(currentReservation?.session_status) &&
                  pdfs.length === 0 &&
                  images.length === 0 &&
                  setOpenPickers(!openPickers)
                }
              >
                <AddRoundedIcon
                  className={
                    openPickers ? "rotate__forward" : "rotate__backward"
                  }
                />
              </div>

              <div className="textarea__wrapper">
                <TextareaAutosize
                  autoFocus
                  value={chatText}
                  rowsMax={chatText === "" ? 1 : 4}
                  className="livesession__commentSectionInput blazeres__input"
                  aria-label="maximum height"
                  placeholder={
                    isChattingDisabled(currentReservation?.session_status)
                      ? "Session has ended."
                      : "Type your doubt here ..."
                  }
                  disabled={
                    isChattingDisabled(currentReservation?.session_status) ||
                    images.length > 0 ||
                    pdfs.length > 0
                  }
                  onChange={(e) =>
                    changeRef.current && setChatText(e.target.value)
                  }
                  onKeyDown={(e) => {
                    if (
                      chatText.trim() !== "" ||
                      images.length !== 0 ||
                      pdfs.length !== 0
                    ) {
                      if (e.key === "Enter" && !e.shiftKey) {
                        changeRef.current = false;
                        handleMessageSubmit();
                      } else {
                        changeRef.current = true;
                      }
                    }
                  }}
                />
              </div>
              <button
                onClick={handleMessageSubmit}
                className="livesession__commentSectionButton blazeres__btn"
                disabled={
                  chatText.trim() === "" &&
                  images.length === 0 &&
                  pdfs.length === 0
                }
                aria-label="blazeres__btn"
              >
                {isSending ? (
                  <div className="circular__progress__lottie">
                    <Lottie
                      options={{ loop: true, animationData: circularProgress }}
                    />
                  </div>
                ) : (
                  <SendIcon
                    className="blaze-send-icon"
                    color={
                      chatText.trim() === "" &&
                      images.length === 0 &&
                      pdfs.length === 0
                        ? "grey"
                        : "var(--color-highlight)"
                    }
                  />
                )}
              </button>
            </div>
          </div>

          <div className="reservation__sidebar__wrapper">
            <div className="reservation__sidebar__container">
              <div className="reservation__details__wrapper">
                <div
                  className="reservation__details fadeIn"
                  style={{
                    background: currentReservation?.subject_color_gradient[0],
                  }}
                >
                  <div className="reservation__name">
                    {currentReservation?.topic}
                  </div>
                </div>
              </div>
              <div className="reservation__sidebar__about__wrapper">
                {currentReservation?.instructor_name ? (
                  <div className="reservation__sidebar__header">
                    <h3>Know your Expert</h3>
                    <div className="instructor-details">
                      <div className="instructor-inner">
                        {currentReservation?.instructor_profile_pic && (
                          <div className="instructor-img">
                            <img
                              src={currentReservation?.instructor_profile_pic}
                              className="image__instructor"
                              draggable={false}
                              alt="ins"
                            />
                            <img
                              src={verfifiedCheck}
                              alt="v"
                              className="image__verified"
                              draggable={false}
                            />
                          </div>
                        )}
                        <section>
                          <div>
                            <h4>
                              {currentReservation?.instructor_name
                                ? currentReservation.instructor_name?.split(
                                    " "
                                  )[0] + " Sir"
                                : ""}
                            </h4>
                            {/*{instructorRating > 0 && (*/}
                              <StarRatings
                                name="rating"
                                numberOfStars={5}
                                starSpacing="2px"
                                starDimension="20px"
                                rating={instructorRating ?? 0}
                                svgIconPath={starPath}
                                starRatedColor="#fec107"
                                starHoverColor="#fec107"
                                svgIconViewBox="0 0 207.802 207.748"
                              />
                            {/*)}*/}
                          </div>
                          <h6>
                            PuStack {subjectName(currentReservation?.skill)}{" "}
                            Expert
                          </h6>
                        </section>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="reservation__sidebar__header">
                    <h3>About</h3>
                    <p>These are some details about this blaze session.</p>
                  </div>
                )}
              </div>
              {currentReservation?.instructor_name && (
                <div className="reservation__sidebar__container">
                  <div className="reservation__sidebar__header ">
                    <h3>This Session</h3>
                    <h6>
                      <img
                        src={roundedVideoCamera}
                        alt="vid"
                        className="video-cam"
                        draggable={false}
                      />
                      <p>{getTotalCallDuration()}</p>
                    </h6>
                  </div>
                </div>
              )}
            </div>

            <div className="reservation__sidebar__container">
              <div className="reservation__sidebar__header">
                <h3>Files</h3>
                <p>Shared here in this conversation.</p>
              </div>

              <div
                className="reservation__sidebar__content"
                style={{
                  overflowY: chatDocuments !== null ? "auto" : "inherit",
                }}
              >
                {(chatDocuments === null || chatDocuments?.length === 0) && (
                  <div className="sidebar__placeholder">
                    <div className="sidebar__placeholder__icon">
                      <img
                        src={noFilesIcon}
                        alt="No Documents | PuStack"
                        draggable={false}
                      />
                    </div>
                    <div className="sidebar__placeholder__text">
                      No documents present.
                    </div>
                  </div>
                )}
                {chatDocuments?.map((chat, index) => (
                  <div className="reservation__sidebar__item__file" key={index}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${chat?.url}`}
                    >
                      <img
                        src={pdfIcon}
                        alt="Pustack Document"
                        className="attachment__icon"
                        draggable={false}
                      />
                      <div className="file__details">
                        <div className="file__name">{chat?.name}</div>
                        <div className="file__date">
                          {chat?.timestamp?.getDate()}{" "}
                          {monthToStringFormatter(chat?.timestamp?.getMonth())},{" "}
                          {chat?.timestamp?.getFullYear()}
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="reservation__sidebar__container">
              <div className="reservation__sidebar__header">
                <h3>Media</h3>
                <p>Shared here in this conversation.</p>
              </div>

              <div className="reservation__sidebar__content image__content">
                {(chatImages === null || chatImages?.length === 0) && (
                  <div className="sidebar__placeholder">
                    <div className="sidebar__placeholder__icon">
                      <img
                        src={noImagesIcon}
                        alt="No Documents | PuStack"
                        draggable={false}
                      />
                    </div>
                    <div className="sidebar__placeholder__text">
                      No media present.
                    </div>
                  </div>
                )}
                {chatImages?.map((e, index) => (
                  <div
                    key={index}
                    className="reservation__sidebar__item__img"
                    onClick={() => setisModalOpen(true)}
                  >
                    <img
                      src={e.url}
                      alt="Pustack Document"
                      className="attachment__image"
                      draggable={false}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {chatImages !== null && isModalOpen && (
        <ModalGallery
          body={chatImages.map((e) => e.url)}
          onClose={() => setisModalOpen(false)}
        />
      )}
      <Snackbar
        open={openSnack}
        message={message}
        key={"bottom" + "center"}
        onClose={handleSnackClose}
        TransitionComponent={Fade}
        className={isDark ? "snackbar snackbarDark" : "snackbar"}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      <Modal
        ariaHideApp={false}
        isOpen={openBlazeCall}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={handleBlazeCallClose}
        overlayClassName="new-post-modal-overlay"
        className={isDark ? "skills__modal dark" : "skills__modal"}
      >
        <BlazeStudentCall
          closeModal={handleBlazeCallClose}
          chatData={chatsData}
          currentReservation={currentReservation}
          moreChat={moreChat}
          getMoreChatsFn={getMoreChatsFn}
        />
      </Modal>
    </>
  );
}
